<template>
  <section class="article-detail">
    <div class="article-detail__container">
      <h1 class="article-detail__title">What is Wilks?</h1>
      <div class="article-detail__content">
        <p>You might have seen the term <i>“Wilks”</i> being used at powerlifting meets and all around the internet — on this website, for instance! But, what is Wilks exactly?</p>

        <p>Wilks is a widely used term in powerlifting, but is actually shorthand for Wilks Coefficient or Wilks Formula. The author of the formula is Robert Wilks, CEO of <a href="https://powerliftingaustralia.com/" target="_blank">Powerlifting Australia</a>. The current version of the Wilks calculation is being used in the <a href="http://www.powerlifting-ipf.com/" target="_blank">International Powerlifting Federation (IPF)</a> since 1998.</p>

        <p>When using the Wilks calculation, only two variables are needed of the lifter: bodyweight and total amount of weight lifted. The result of the calculation is the relative strength of the lifter — which is often called the Wilks score/points. This result is useful when comparing multiple lifters with each other. A 105kg male lifter (with a 700kg total) might have a larger <b>absolute strength</b>, when being compared with a 66kg male lifter (with a 600kg total), but the 66kg lifter has a larger <b>relative strength</b> (418 Wilks vs. 471 Wilks).</p>

        <p>Calculate your Wilks <router-link to="/">here</router-link>.</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'article-detail',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.article-detail{
  &__container{
    @include vw-size('padding-top', 37, 0, 1);
    @include vw-size('padding-bottom', 37, 0, 1);
    @extend %container;
    @include vw-size('max-width', 550, 0, 1);
    font-family: $ff-source;
    margin-left: 0;

    @media (max-width: 767px) {
      width:100%;
    }
  }
  &__title{
    @include vw-size('font-size', 22, 0, 1);
    margin-top:0;
    font-weight:400;
  }
  &__content{
    @extend %content;
    @include vw-size('font-size', 16, 0, 1);
    line-height: 1.65;
    font-weight:300;

    b, strong{
      font-weight:400;
    }
    a{
      color: $c-lightblue; 
      text-decoration:none;
      position: relative;
      display:inline-block;

      &:after{
        @include vw-size('bottom', -2, 0, 1);
        border-bottom:1px solid $c-lightblue;
        @include vw-size('border-width', 1, 0, 1);
        content:"";
        position:absolute;
        left:0;
        right:0;
        opacity: 0;
        transform:translateY(-4px);
        transition:all 200ms ease-in-out;
      }

      &:hover:after{
        transform:translateY(-2px);
        opacity: 1;
      }

      &:hover, &:focus, &:active, &:visited{
        text-decoration:none;
        color: $c-lightblue; 
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleDetail/ArticleDetail.vue